import { render, staticRenderFns } from "./AKButton.vue?vue&type=template&id=31214bf7&scoped=true&"
import script from "./AKButton.vue?vue&type=script&lang=js&"
export * from "./AKButton.vue?vue&type=script&lang=js&"
import style0 from "./AKButton.vue?vue&type=style&index=0&id=31214bf7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31214bf7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
